/* eslint-disable react-hooks/exhaustive-deps */
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";
import {
  useSelector,
  // useStore
} from "react-redux";
import { ToastContainer } from "react-toastify";
import { NewLoginPage } from "./components/edgeCases/NewLoginPage";

import ClarityTracker from "./components/analytics/ClarityTracker";


// Pages
import LoginPage from "./pages/Login";
import SettingsComponent from "./pages/settings/Settings";
import MyTaskHistory from "./pages/myTaskHistory/MyTaskHistoryTable";
import MyTaskTable from "./pages/myTask/My-task-table";
import JournalOverview from "./pages/journalOverview/JournalOverview";
import IssueOverviewTable from "./pages/issueOverview/IssueOverviewTable";
import TaskAssignmentPage from "./pages/taskAssignment/TaskAssignment";
import SessionLogout from "./components/edgeCases/SessionLogout";

// Layout
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";

// Other Components
import ReloadPage from "./components/edgeCases/Reload";
import OfflineOverlay from "./components/edgeCases/OfflinePage";
import CheckPermission from "./components/edgeCases/PermissionPage";
import CheckDataSync from "./components/edgeCases/dataSync";
import LoadingPage from "./components/edgeCases/LoadingPage";
import { LoginFailure } from "./components/edgeCases/LoginFailure";

// Utilities
// import { checkSessionTimeout } from "./store/sessionMiddleware";

//socket
import socket from "./components/Socket";

import SamlCallback from "./components/samlCallBack";
import { TokenExpired } from "./services/apiService/authApi";

const AppLayout = ({
  isSidebarOpen,
  toggleSidebar,
  activeTab,
  setActiveTab,
  isLoading,
  setIsLoading,
  setIsReload,
}) => {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Header
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isLoading={isLoading}
      />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          isOpen={isSidebarOpen}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isLoading={isLoading}
        />
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route
              path="/"
              element={
                <MyTaskTable setLoad={setIsLoading} setIsReload={setIsReload} />
              }
            />
            <Route
              path="/settings"
              element={
                <SettingsComponent
                  active={activeTab}
                  setLoading={setIsLoading}
                  setIsReload={setIsReload}
                />
              }
            />
            <Route
              path="/history"
              element={
                <MyTaskHistory
                  active={activeTab}
                  setLoading={setIsLoading}
                  setIsReload={setIsReload}
                />
              }
            />
            <Route
              path="/assignment"
              element={
                <TaskAssignmentPage
                  active={activeTab}
                  setLoading={setIsLoading}
                  setIsReload={setIsReload}
                />
              }
            />
            <Route
              path="/journals"
              element={
                <JournalOverview
                  active={activeTab}
                  setLoading={setIsLoading}
                  setIsReload={setIsReload}
                />
              }
            />
            <Route
              path="/myTask"
              element={
                <MyTaskTable setLoad={setIsLoading} setIsReload={setIsReload} />
              }
            />
            <Route
              path="/issues"
              element={
                <IssueOverviewTable
                  setLoading={setIsLoading}
                  setIsReload={setIsReload}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  //   const store = useStore();

  const { isAuth, isSessionTimedOut } = useSelector((state) => state.auth);
  const { userData } = useSelector((state) => state.user);

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("My Tasks");
  const [isLoading, setIsLoading] = useState(false);
  const [isReload, setIsReload] = useState(false);

  useEffect(() => {
    socket.connect();
    // tokenExpired();
    console.log("Socket connected >>");

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (userData?.id) {
      socket.emit("register", userData.id);
    }
  }, [userData?.id]);

  useEffect(() => {
    if (!userData || Object.keys(userData).length === 0) {
      navigate("/login");
    }
  }, [userData]);

  useEffect(() => {
    const excludedPaths = [
      "/saml2/sso/azure",
      "/loginFailure",
      "/loading",
      "/sso",
    ];
    if (!isAuth && !excludedPaths.includes(location.pathname)) {
      navigate("/login");
    }
  }, [isAuth, isSessionTimedOut, navigate]);

  // Warn on window/tab close
  //   useEffect(() => {
  //     const handleBeforeUnload = (event) => {
  //       event.preventDefault();
  //       event.returnValue = "";
  //     };

  //     window.addEventListener("beforeunload", handleBeforeUnload);

  //     return () => {
  //       window.removeEventListener("beforeunload", handleBeforeUnload);
  //     };
  //   }, []);

  // Session Timeout Handler
  // useEffect(() => {
  //   if (!isAuth) return;

  //   const interval = setInterval(() => {
  //     if (checkSessionTimeout(store)) {
  //       navigate("/session-logout");
  //     }
  //   }, 60000);

  //   const handleActivity = () => {
  //     const excludedPaths = ["/login", "/session-logout"];
  //     if (!excludedPaths.includes(location.pathname)) {
  //       store.dispatch({ type: "auth/updateLastActivity" });
  //     }
  //   };

  //   const events = [
  //     "mousedown",
  //     "mousemove",
  //     "keydown",
  //     "scroll",
  //     "touchstart",
  //     "click",
  //   ];
  //   // events.forEach((e) => window.addEventListener(e, handleActivity));

  //   return () => {
  //     clearInterval(interval);
  //     events.forEach((e) => window.removeEventListener(e, handleActivity));
  //   };
  // }, [isAuth, navigate, store, location.pathname]);

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  if (isReload) return <ReloadPage />;

  return (
    <>
          {!isAuth && <ClarityTracker />}

      {/* <ToastContainer
        limit={1}
        autoClose={40000}
        closeOnClick={false}
        closeButton={false}
        position="bottom-left"
        hideProgressBar
        className="!bg-transparent !shadow-none !p-0 !w-full min-w-[350px] max-w-[90vw]"
        bodyClassName="!bg-transparent !p-0 !w-full"
         toastClassName="!w-full !max-w-[80vw]" 
        stacked={false}
      /> */}
      <ToastContainer
        limit={1}
        autoClose={40000}
        closeOnClick={false}
        closeButton={false}
        position="bottom-left"
        hideProgressBar
        className="!bg-transparent !shadow-none !p-0"
        bodyClassName="!bg-transparent !p-0"
        toastClassName="!inline-block !w-auto !max-w-full !min-w-[auto]"
        stacked={false}
      />
      <Routes>
        <Route path="/loginFailure" element={<LoginFailure />} />
        <Route path="/sso" element={isAuth ? <Navigate to="/myTask" replace /> : <NewLoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/session-logout" element={<SessionLogout />} />
        <Route path="/saml2/sso/azure" element={<SamlCallback />} />
        <Route
          path="/loading"
          element={
            <LoadingPage
              onComplete={() => navigate("/myTask", { replace: true })}
            />
          }
        />

        {/* {isAuth &&  */}
        {!isSessionTimedOut ? (
          <Route
            path="/*"
            element={
              <CheckDataSync>
                <CheckPermission>
                  <OfflineOverlay>
                    <AppLayout
                      isSidebarOpen={isSidebarOpen}
                      toggleSidebar={toggleSidebar}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      isLoading={isLoading}
                      setIsLoading={setIsLoading}
                      setIsReload={setIsReload}
                    />
                  </OfflineOverlay>
                </CheckPermission>
              </CheckDataSync>
            }
          />
        ) : (
          <Route
            path="*"
            element={
              <Navigate to={isSessionTimedOut ? "/session-logout" : "/login"} />
            }
          />
        )}
      </Routes>
    </>
  );
};

export default App;
